/**
 * 訂單列表的查詢區間守衛，兩個訂單頁共用。
 *
 * DateRangePicker 的 OK 按鈕沒有檢查是否選滿兩個日期，清空時還會 emit []，
 * 所以每個守衛都必須先確認拿到的是兩個元素 —— 否則 new Date(undefined) 會
 * 讓比較結果變成 NaN，被誤判成「區間不合規」。
 */

const isRange = dates => Array.isArray(dates) && dates.length === 2 && dates[0] && dates[1];

export const OrderDateGuardMixin = {
  methods: {
    // 區間不完整時放行，交由 loadUrl 的 moment 預設值處理。
    guardDateRange(dates) {
      if (!isRange(dates)) return true;
      if (Math.abs(new Date(dates[1]) - new Date(dates[0])) <= 7 * 86400000) return true;

      this.$notify({
        text: this.$t('views.orders.dateRangeExceedsOneWeek'),
        type: 'error'
      });
      return false;
    },

    // 單日 = 起訖同一天。相差 1 天其實橫跨 48 小時（loadUrl 用 startOf/endOf day
    // 展開），對無索引的 ddpw.orders.amount 掃兩天正是這個守衛要避免的負載。
    isSingleDay(dates) {
      return isRange(dates)? dates[0] === dates[1]: true;
    }
  }
};
